export class UserBlockedError extends Error {
  blockedReason: string;

  constructor(message: string, blockedReason: string) {
    super(message);
    this.blockedReason = blockedReason;
  }
}